import { useEffect, useState } from "react";
import { Grid } from "@mui/material";

import { useAxios, useComponent } from "../../hooks";
import SelectRole from "./login user components/SelectRole";

export default function AdminLandingPage() {
  const axios = useAxios();
  const { loader } = useComponent();

  const [brands, setBrands] = useState([]);
  const [loadingBrands, setLoadingBrands] = useState(false);

  useEffect(() => {
    loader.start(1);
    setLoadingBrands(true);

    axios({
      url: "/getAllBrands?adminLandingPage=true",
      method: "GET",
    }).then((response) => {
      if (response.status) {
        let brandList = [];
        for (const brand of response?.data.parsedBrands) {
          brandList.push({
            ID: brand.brand_id,
            about: brand.about,
            brandName: brand.brand_name,
            logo: !!brand.logo
              ? brand.logo
              : "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/NaN_logo.png",
            languages: brand.languages,
            locations: brand.audience_location,
            category: brand.site_category,
            mau: brand.mau,
            onlineStore: brand.online_store,
            website: brand.website,
            socialMedia: brand.social_media_handles,
            brandType: brand.brand_type_id,
            isBrandVerified: brand.brand_verification_status,
            businessEntityID: brand.business_entity_id,
          });
        }
        brandList.slice().sort((a, b) => {
          if (a.brandName.toLowerCase() === b.brandName.toLowerCase()) {
            return a.brandName > b.brandName ? 1 : -1;
          }
          return a.brandName > b.brandName ? 1 : -1;
        });
        setBrands(brandList);
        setLoadingBrands(false);
        loader.apiComplete();
      }
    });
  }, [axios, loader]);

  return (
    <Grid container spacing={2}>
      <Grid size={12} style={{ paddingTop: "0px" }}>
        <SelectRole
          loadingBrands={loadingBrands}
          brands={brands}
          component="admin"
        />
      </Grid>
    </Grid>
  );
}
